var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgParkinginline = function SvgParkinginline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71,
    height: 71,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00A98F",
    d: "M29.776 48.273h-2.68V22.306h8.608a7.59 7.59 0 0 1 7.62 7.62 7.59 7.59 0 0 1-7.62 7.622h-5.928v10.725Zm0-13.266h5.928c2.681 0 4.94-2.258 4.94-4.939s-2.259-4.94-4.94-4.94h-5.928v9.88Z"
  })));
};
export default SvgParkinginline;